import { createSlice } from '@reduxjs/toolkit'

export const appReducer = createSlice({
    name: 'user',
    initialState: {
      profile:{
        "Country Code": "",
        "Mobile Number": "",
        "Do you identify as male?": "",
        "Birth Date": "",
        "First Name": "",
        "Last Name": "",
        "Do you have any known medical conditions?": {
          "Answer": "",
          "Please specify (if yes)": ""
        },
        "Are you currently on any medications?": {
          "Answer": "No",
          "Please specify (if yes)": ""
        },
        "Do you have any known allergies?": {
          "Answer": "Yes",
          "Please specify (if yes)": ""
        },
        "Have you had any prior reactions to medications or treatments?": {
          "Answer": "No",
          "Please specify (if yes)": ""
        },
        "Have you undergone any prior treatments for hair loss or scalp conditions?": {
          "Answer": "Yes",
          "Please specify (if yes)": ""
        },
        "Have you used any hair growth products in the past?": {
          "Answer": "No",
          "Please specify (if yes)": ""
        },
        "Are there any known contraindications regarding the prescribed compounded product?": {
          "Answer": "No",
          "Please specify (if yes)": ""
        },
        "Has the compounder been informed of any known risks related to your medication or health status?": {
          "Answer": "Yes",
          "Please specify (if yes)": ""
        },
        "Topview":"",
        "Frontview":"",
        "Backview":"",
        "Leftview":"",
        "Rightview":"",
        "activeview":"",
        'reportstate':true,
        locale: "en",
        maskConsent: '',
        Gender: ''
      }},
    reducers: {
      setcountrycode:(state,action) =>{        
        state.profile['Country Code'] = action.payload
      },
      setmobnum:(state,action) =>{
        state.profile['Mobile Number'] = action.payload
      },
      setidentasmale:(state,action) =>{
        state.profile['Do you identify as male?'] = action.payload
      },
      setfname:(state,action) =>{
        state.profile['First Name'] = action.payload
      },
      setlname:(state,action) =>{
        state.profile['Last Name'] = action.payload
      },
      setbday:(state,action) =>{
        state.profile['Birth Date'] = action.payload
      },
      setknownmedicalconditions:(state,action) =>{
        state.profile['Do you have any known medical conditions?'] = action.payload
      },
      setcurrentlyonanymedications:(state,action) =>{
        state.profile['Are you currently on any medications?'] = action.payload
      },
      setknownallergies:(state,action) =>{
        state.profile['Do you have any known allergies?'] = action.payload
      },
      setpriorreactionstomedications:(state,action) =>{
        state.profile['Have you had any prior reactions to medications or treatments?'] = action.payload
      },
      setpriortreatmentsforhairloss:(state,action) =>{
        state.profile['Have you undergone any prior treatments for hair loss or scalp conditions?'] = action.payload
      },
      sethairgrowthproductsinthepast:(state,action) =>{
        state.profile['Have you used any hair growth products in the past?'] = action.payload
      },
      setknowncontraindications:(state,action) =>{
        state.profile['Are there any known contraindications regarding the prescribed compounded product?'] = action.payload
      },
      setcompounderbeeninformed:(state,action) =>{
        state.profile['Has the compounder been informed of any known risks related to your medication or health status?'] = action.payload
      },
      setfrontview:(state,action) =>{
        state.profile.Frontview= action.payload
      },
      settopview:(state,action) =>{
        state.profile.Topview= action.payload
      },
      setbackview:(state,action) =>{
        state.profile.Backview= action.payload
      },
      setleftview:(state,action) =>{
        state.profile.Leftview= action.payload
      },
      setrightview:(state,action) =>{
        state.profile.Rightview= action.payload
      },
      setactiveview:(state,action) =>{
        state.profile.activeview= action.payload
      },
      setreportstate:(state,action) =>{
        state.profile.reportstate= action.payload
      },
      setlocale: (state, action) => {
        state.profile.locale = action.payload;
      },
      setmaskcontent: (state, action) => {
        state.profile.maskConsent = action.payload;
      },
      setgender: (state, action) => {
        state.profile.Gender = action.payload;
      },
    },
  })
  
  // Action creators are generated for each case reducer function
  export const {setbday,setcompounderbeeninformed,setcountrycode,setcurrentlyonanymedications,setfname,sethairgrowthproductsinthepast,setidentasmale,setknownallergies,setknowncontraindications,setknownmedicalconditions,setlname,setmobnum,setpriorreactionstomedications,setpriortreatmentsforhairloss,setfrontview,setbackview,setleftview,setrightview,settopview,setactiveview,setreportstate, setlocale, setmaskcontent, setgender} = appReducer.actions
  
  export default appReducer.reducer